<template>
  <SideBarLayoutContent>
    <template #top-bar>
      <div class="flex grow flex-row items-center">
        <h1 class="text-display-small grow">{{ $t('mainNavigation.objectives') }}</h1>
        <div class="flex items-center justify-end gap-1">
          <BaseTextButton
            color="text"
            icon="archive"
            class="text-on-surface-variant!"
            size="M"
            @click="openArchivedObjectives"
          >
            {{ $t('coaching.objectives.archived.action') }}
          </BaseTextButton>
          <BaseTextButton color="filled" icon="add" size="M" @click="createObjective">
            {{ $t('objective.create.action') }}
          </BaseTextButton>
        </div>
      </div>
    </template>
    <LoadingWrapper :state="status">
      <MemberObjectivesContent
        :status="status"
        :objectives="data.objectives"
        :feedback-topics="feedbackTopics"
        :show-form="showForm"
        :creatable-objective="creatableObjective"
        @create="createObjective"
        @cancel-create="cancelCreateObjective"
        @save="saveObjective"
      />
    </LoadingWrapper>
    <UnsavedChangesDialog
      :is-open="showConfirmDialog"
      @confirm="confirmLeave"
      @dismiss="cancelLeave"
    />
  </SideBarLayoutContent>
</template>

<script lang="ts" setup>
  import { computed, watch } from 'vue'
  import { useRouter } from 'vue-router'
  import SideBarLayoutContent from '@/core/components/layouts/SideBarLayoutContent.vue'
  import MemberObjectivesContent from '@/core/components/objective/MemberObjectivesContent.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import { useMyObjectives } from '@/core/composables/use-my-objectives'
  import { useCompleteFeedbackTopics } from '@/core/composables/use-complete-feedback-topics'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import { useUnsavedChanges } from '@/core/composables/use-unsaved-changes'
  import UnsavedChangesDialog from '@/core/components/unsaved-changes-dialog/UnsavedChangesDialog.vue'

  const router = useRouter()
  const {
    data,
    status,
    showForm,
    creatableObjective,
    createObjective,
    cancelCreateObjective,
    saveObjective,
  } = useMyObjectives()

  const { showConfirmDialog, confirmLeave, cancelLeave, setSourceDirty } = useUnsavedChanges()

  const { data: topicsData } = useCompleteFeedbackTopics()

  const feedbackTopics = computed(() => topicsData.value?.feedbackTopics ?? [])

  const createFormHasContent = computed(() => {
    if (!showForm.value) {
      return false
    }
    return !!(
      creatableObjective.title?.trim() ||
      creatableObjective.description?.trim() ||
      creatableObjective.feedbackTopicId
    )
  })

  watch(
    createFormHasContent,
    (dirty) => {
      setSourceDirty('create-form', dirty)
    },
    { immediate: true },
  )

  const openArchivedObjectives = () => {
    router.push({ name: 'archived-objectives' })
  }
</script>
